import { SEVERITIES } from '@prerender/diagnostics-api';
import type { IncidentDomainResponse } from '@prerender/diagnostics-api';

export type DomainSortKey = 'domain' | 'severity';

export type DomainSort = {
  readonly key: DomainSortKey;
  readonly direction: 'ascending' | 'descending';
};

export type AriaSort = DomainSort['direction'] | 'none';

const COMPARE_BY: Record<DomainSortKey, (left: IncidentDomainResponse, right: IncidentDomainResponse) => number> = {
  domain: (left, right) => left.domain.localeCompare(right.domain),
  severity: (left, right) => SEVERITIES.indexOf(right.severity) - SEVERITIES.indexOf(left.severity),
};

export function sortedBy(
  rows: readonly IncidentDomainResponse[],
  sort: DomainSort | null
): readonly IncidentDomainResponse[] {
  if (sort === null) return rows;

  const sign = sort.direction === 'ascending' ? 1 : -1;

  return [...rows].sort((left, right) => sign * COMPARE_BY[sort.key](left, right));
}

export function nextSort(current: DomainSort | null, key: DomainSortKey): DomainSort {
  return current?.key === key && current.direction === 'ascending'
    ? { key, direction: 'descending' }
    : { key, direction: 'ascending' };
}

export function ariaSortOf(sort: DomainSort | null, key: DomainSortKey): AriaSort {
  return sort?.key === key ? sort.direction : 'none';
}

export function matchesSearch(domain: string, search: string): boolean {
  return domain.toLowerCase().includes(search.trim().toLowerCase());
}
